import {
  MAX_ALLOWED_AGE,
  MIN_ALLOWED_AGE,
} from '../components/form-fields/birth-data-picker/utils';

export const STRINGS: Record<string, Record<string, string>> = {
  ERRORS: {
    ACCESS_CODE_NOT_AVAILABLE:
      'This access code is not available. Please contact us at <a href="mailto:support@pivot.co">support@pivot.co</a> to make sure you have the correct code.',
    EMAIL_EXISTS_IN_SYSTEM: `Email is already in system`,
    INVALID_INPUT: 'Input is not valid',
    MISSING: 'Please complete this field',
    SOMETHING_WRONG: 'Oops, looks like there was an error',
    SOMETHING_WRONG_RETRY:
      'Oops, looks like there was an error, please try again in a few moments',
    RESULTS_NOT_SAVED_RETRY:
      'Oops, we could not save your Flex Score, please try again in a few moments',
    SOMETHING_WRONG_CONTACT_SUPPORT:
      'Oops, looks like there was an error. Please reach out to <a href="mailto:support@pivot.co">support@pivot.co</a> for help',
    USER_NOT_INITIALIZED:
      'You already have an account.<br />Log in using the app to complete registration.',
    USER_NOT_CONFIRMED:
      'You&apos;ve already signed up, please verify your email.',
    EMAIL_NOT_VALID: 'Email is not a valid address',
    INCORRECT_VERIFICATION_CODE:
      'The verification code you entered is incorrect',
    PASSWORDS_DONT_MATCH: 'Passwords don&apos;t match',
    INIT_ERROR: 'InitializationError',
    ENROLLMENT_ERROR: 'EnrollmentError',
    SIGN_IN_ERROR: 'SignInError',
    CREATE_ACCOUNT_ERROR: 'CreateAccountError',
    ACCESS_CODE_ERROR: 'AccessCodeError',
    USER_NOT_INITIALISED_ERROR: 'UserNotInitialisedError',
    AGE_RANGE_PROBLEM: `Pivot is built for people from ages ${MIN_ALLOWED_AGE} through ${MAX_ALLOWED_AGE}. Sorry!`,
    INVALID_DATE: 'Invalid date',
  },
  WCAG: {
    SUBMIT_BUTTON_DISABLED:
      'Submit button has been disabled until all fields are completed',
  },
  SUCCESS: {
    PASSWORD_RESET_EMAIL_SENT:
      'An email was sent - you&apos;ll now be redirected to reset your password',
    PASSWORD_RESET_SUCCESS:
      'Password has been updated successfully - you&apos;ll now be redirected to log in',
    SMS_SENT:
      'Great news! We&apos;ve sent the app download link to your phone number.',
    THANKS: 'Thanks!',
    SAVED_FEEDBACK: 'Thank you! Your feedback is appreciated and recorded.',
  },
};
